"use client"
import React, { useState, useEffect } from "react";

import "@/components/shared/ProgressBar.css";

const PageScrollProgressBar = ({
  className,
  width,
  foreground,
  background
}) => {
  const foregroundColor = foreground ?? "#F55F2D";
  const backgroundColor = background ?? "#E4E4E4";

  const [widgetWidth, setWidgetWidth] = useState(275);
  const [foregroundWidth, setForegroundWidth] = useState(0);

  useEffect(() => {
    if (width) {
      setWidgetWidth(width);
    }
  }, [width]);

  useEffect(() => {
    document.addEventListener("scroll", handleWindowScroll);
  }, []);

  const handleWindowScroll = e => {
    setForegroundWidth(_get_scroll_percentage());
  };

  /**
   * Get current browser viewpane heigtht
   */
  const _get_window_height = () => {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      0
    );
  };

  /**
   * Get current absolute window scroll position
   */
  const _get_window_Yscroll = () => {
    return (
      window.pageYOffset ||
      document.body.scrollTop ||
      document.documentElement.scrollTop ||
      0
    );
  };

  /**
   * Get current absolute document height
   */
  const _get_doc_height = () => {
    return Math.max(
      document.body.scrollHeight || 0,
      document.documentElement.scrollHeight || 0,
      document.body.offsetHeight || 0,
      document.documentElement.offsetHeight || 0,
      document.body.clientHeight || 0,
      document.documentElement.clientHeight || 0
    );
  };

  /**
   * Get current vertical scroll percentage
   */
  const _get_scroll_percentage = () => {
    var min = _get_window_Yscroll() / _get_window_height();
    var max =
      (_get_window_Yscroll() + _get_window_height()) / _get_doc_height();

    var pct = max;
    if (_get_window_Yscroll() < _get_window_height()) {
      pct = min * max;
    }

    return pct * 100;
  };

  return (
    <div
      className={`progress-bar ${className ?? ""}`}
      style={{ width: widgetWidth }}
    >
      <div
        className="background"
        style={{ backgroundColor: backgroundColor, width: "100%" }}
      >
        <div
          className="completed"
          style={{
            backgroundColor: foregroundColor,
            width: `${foregroundWidth}%`
          }}
        />
      </div>
    </div>
  );
};
export default PageScrollProgressBar;
